import { LabelValueHint } from '@lib/types';
import {
  DesignSizeTypeTypes,
  InputTemplatesWebsiteFilter,
  InputTemplatesWebsiteOrderBy,
} from 'graphql/generated/types.autogenerated';

export type GetTemplateType = {
  filter: InputTemplatesWebsiteFilter;
  orderBy?: InputTemplatesWebsiteOrderBy;
  limit?: number;
  offset?: number;
};

export type TemplateSectionFilterQueryType = {
  color?: string[];
  style?: string[];
  type?: string[];
  size?: string[];
  industry?: string[];
  page?: string;
  query?: string | null;
};

export const GetTemplateLimit = 20;

export type GetTemplatesProps = {
  designSizeTypes?: number[] | null;
  categories?: number[] | null;
  tags?: number[] | null;
  type?: DesignSizeTypeTypes;
  offset?: number;
  limit?: number;
  search?: string;
};

export type GetTemplateFiltersType = {
  category: {
    documentCategories?: number[] | null;
    dbCategories?: LabelValueHint[];
  };
  tag: {
    documentTags?: number[] | null;
    dbStyles?: LabelValueHint[];
    dbColors?: LabelValueHint[];
  };
  size: {
    documentDesignSizeTypes?: number[] | null;
    dbDesignSizeTypes?: LabelValueHint[];
  };
  filterSelection: FilterSelectionProp;
};

export type FilterSelectionProp = {
  color?: (string | number)[];
  style?: (string | number)[];
  type?: (string | number)[];
  size?: (string | number)[];
  industry?: (string | number)[];
  page?: string | number;
  query?: string | number;
};

export const DESIGN_SIZE_TYPE_TYPES = [
  { value: DesignSizeTypeTypes.ANIMATED, label: 'Animated' },
  { value: DesignSizeTypeTypes.STATIC, label: 'Static' },
];
